import { render, staticRenderFns } from "./SavedProductsOverview.vue?vue&type=template&id=016ddecb"
import script from "./SavedProductsOverview.vue?vue&type=script&lang=js"
export * from "./SavedProductsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports